import "./Sustainability2.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import Sustainabilitypillars from "./sections/Sustainabilitypillars";
import SocialImpact from "./sections/SocialImpact";
import CertificationsRecognition from "./sections/CertificationsRecognition";
import Footer from "@/reusable_sections/Footer";
import Environmentalcommitments from "./sections/Environmentalcommitments";
export default function Sustainability2Page() {
  return <div>
      <Header />
      <HeroBanner />
      <Sustainabilitypillars />
      <Environmentalcommitments />
      <SocialImpact />
      <CertificationsRecognition />
      <Footer />
    </div>;
}